export default "__VITE_ASSET__CX8H6mpV__"